/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PagedResponse } from "models/paged-response";
import { GetPostsPaginatedRequest, GetPostsPaginatedState, PostagemPaged } from "store/modules/posts/types";

const initialState: GetPostsPaginatedState = {
    isRequesting: false,
    successPayload: {
        hasNextPage: false,
        hasPreviousPage: false,
        indexFrom: 0,
        items: [],
        pageIndex: 0,
        pageSize: 10,
        totalCount: 0,
        totalPages: 0
    },
    errors: []
};

const getPostsPaginatedSlice = createSlice({
    name: "posts@getPostsPaginated",
    initialState,
    reducers: {
        getPostsPaginatedRequest: (
            state,
            action: PayloadAction<GetPostsPaginatedRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        getPostsPaginatedSuccess: (
            state,
            action: PayloadAction<PagedResponse<PostagemPaged>>
        ): void => {
            state.isRequesting = false;
            state.successPayload = action.payload;
        },
        getPostsPaginatedFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        }
    }
});

export const {
    getPostsPaginatedFailed,
    getPostsPaginatedRequest,
    getPostsPaginatedSuccess
} = getPostsPaginatedSlice.actions;
export default getPostsPaginatedSlice.reducer;
